import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=ddf0527a&scoped=true"
import script from "./reportDetails.vue?vue&type=script&lang=js"
export * from "./reportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf0527a",
  null
  
)

export default component.exports